module.exports = __webpack_public_path__ + "static/media/32.1fd69cfe.png";